import {toString} from "../helpers/helpers";

export class SupportResponseModel {
  defectId: string;
  defectUrl: string;

  constructor(json?: any) {
    json = json || {};

    this.defectId = toString(json.defectId);
    this.defectUrl = toString(json.defectUrl);
  }
}
